/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Accounts_DescInputs */

const en_mk_tb_accounts_desc = /** @type {(inputs: Mk_Tb_Accounts_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each developer signs in to their AI locally. A workspace invitation does not share AI credentials, billing access or another person's computer.`)
};

const id_mk_tb_accounts_desc = /** @type {(inputs: Mk_Tb_Accounts_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap developer login ke AI di perangkatnya. Undangan workspace tidak membagikan kredensial AI, akses pembayaran, atau komputer orang lain.`)
};

/**
* | output |
* | --- |
* | "Each developer signs in to their AI locally. A workspace invitation does not share AI credentials, billing access or another person's computer." |
*
* @param {Mk_Tb_Accounts_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_accounts_desc = /** @type {((inputs?: Mk_Tb_Accounts_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Accounts_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_accounts_desc(inputs)
	return en_mk_tb_accounts_desc(inputs)
});